import { captureException } from '@ifixit/sentry';
import { getSnapshot, subscribe, toast } from '@ifixit/ui/lib/toast-queue';
import { _js } from '@ifixit/utils/localize';
import { renderTrackedAsync } from 'Shared/react-mount-tracker';
import { showStashedSuccessToast } from 'Shared/reload_with_toast';

// The one Toaster a page's toasts land in: a page that mounts its own draws
// every toast twice, and no header hosts this on a nanosite or in the app.
//
// Most page views never raise a toast, so the Toaster's code is fetched with
// the first one. Toasts raised while it loads wait in the queue and show when
// it mounts, and their timers start then. If the fetch fails, the toasts
// waiting for it are dropped, since they would show minutes late or never,
// and the next toast tries again.
function mountToasterOnFirstToast() {
   const onQueueChange = () => {
      if (getSnapshot().length === 0) return;
      unsubscribe();
      void mountToaster();
   };
   const unsubscribe = subscribe(onQueueChange);
   // A toast raised before this module ran is already waiting.
   onQueueChange();
}

async function mountToaster() {
   const container = document.createElement('div');
   try {
      document.body.append(container);
      await renderTrackedAsync(container, async () => {
         const { Toaster } = await import('@ifixit/ui/components/toast');
         return (
            <Toaster
               position="bottom-right"
               closeLabel={_js('Close')}
               regionLabel={_js('Notifications (F8)')}
            />
         );
      });
   } catch (error) {
      container.remove();
      console.error('Could not load the Toaster', error);
      captureException(error);
      toast.dismiss();
      mountToasterOnFirstToast();
   }
}

mountToasterOnFirstToast();
showStashedSuccessToast();
